export const InfoIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <circle cx="10" cy="10" r="8.33" stroke="currentColor" strokeWidth="1.5" />
    <path d="M10 10V6.67" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="10" cy="13.33" r="0.83" fill="currentColor" />
  </svg>
);
